export default "__VITE_ASSET__DLsWiPTD__"